<template>
  <v-container>
    <!--InteractiveButton text="Rückmeldung hinzufügen" @click="addFeedback" icon="mdi-plus"
                       background-class="bg_color_pro-rot" v-if="!readonly">
    </InteractiveButton-->
    <v-alert
        v-if="record?.state === State.vorl_beend"
        type="warning"
        variant="tonal"
        class="mb-4"
        icon="mdi-alert"
        title="Rückmeldung vervollständigen!"
    >
      Von <strong>{{ record?.quick_done_by || 'unbekannt' }}</strong>
      am {{ record?.quick_done_at ? new Date(record.quick_done_at).toLocaleString('de-DE') : '?' }}
      als erledigt gemeldet. Bitte Dauer und Text eintragen und mit „Endrückmeldung“ abschließen.
    </v-alert>
    <div class="d-flex justify-space-between">
      <div>
        <v-btn v-if="!readonly" @click="addFeedback">
          <v-icon start>mdi-plus</v-icon>
          Hinzufügen
        </v-btn>
      </div>
      <div>
        <v-btn :disabled="record?.feedbacks.length == 0 || StatePermission[record.state] == 1"
               @click="openPopup">
          <v-icon start>mdi-arrow-right-bold-box</v-icon>
          Aufgabe beenden
        </v-btn>
      </div>
    </div>
    <UniversalPopup ref="closeFeedbackPopup"/>
    <div class="mt-4"/>
    <v-expansion-panels variant="popout">
      <transition-group name="fade-feedback">
        <v-expansion-panel v-for="(panel, index) in panels" :key="index">
          <v-expansion-panel-title class="d-flex">
            <span>Rückmeldung {{ panels.findIndex(fb => fb.id === panel.id) + 1 }}</span>
            <v-spacer></v-spacer>
            <!--v-btn variant="plain" color="red" @click.stop="removeFeedback(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn-->
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea v-model="panel.text" label="Rückmeldung" :variant="useGlobalSetting().globalTextVariant"
                              :disabled="isDisabled(panel)" counter="500" maxLength="500"></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4">
                  <v-text-field v-model="panel.author" :disabled="true" label="Author" :variant="useGlobalSetting().globalTextVariant"/>
                </v-col>
                <v-col cols="4">
                  <v-text-field :model-value="(new Date(panel.created_at)).toLocaleString('de-DE')" :disabled="true" label="Zeitstempel"
                                :variant="useGlobalSetting().globalTextVariant"/>
                </v-col>
                <v-col cols="4">
                  <TimepickerSmall
                      v-model="panel.duration"
                      :disabled="isDisabled(panel)"
                      :required="true"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-checkbox
                      v-model="panel.is_final"
                      :disabled="isDisabled(panel)"
                      color="success"
                      density="compact"
                      hide-details
                      label="Endrückmeldung – Aufgabe abschließen"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </transition-group>
    </v-expansion-panels>
  </v-container>
</template>

<script lang="ts" setup>
import TimepickerSmall from "@/components/inputs/TimepickerSmall.vue";
import {computed, reactive, ref, watch} from "vue";
import {Feedback, State, StatePermission, Task} from "@/types/Order";
import UniversalPopup from "@/components/misc/UniversalPopup.vue";
import CloseFeedbackForm from "@/components/forms/CloseFeedbackForm.vue";
import {getCurrentUser, useGlobalSetting} from "@/lib/utils";

/*
* TODO: duration required
* */

interface Props {
  readonly?: boolean;
  onChange?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  readonly: false
});


const globalSettings = useGlobalSetting();

const record = defineModel<Task>();

const old_feedback = JSON.parse(JSON.stringify(record.value?.feedbacks));

const closeFeedbackPopup = ref<typeof UniversalPopup | null>(null);

const panels = reactive<Feedback[]>(record.value?.feedbacks);//record.value?.tasks[props.index].feedbacks

const getNexId = (): number => {
  if (record.value?.feedbacks.length != 0 && record.value?.feedbacks[record.value.feedbacks.length - 1].id != undefined) {
    return record.value?.feedbacks[record.value.feedbacks.length - 1].id + 1
  }
  return 1;
}

const addFeedback = () => {
  panels.push({
    id: getNexId(),
    task_id: record.value.id,
    author: getCurrentUser(),
    text: "",
    duration: "",
    is_final: false,
    //timestamp: new Date().toISOString().substring(0, 16),
    created_at: new Date().toISOString().substring(0, 16),
    _isNew: true
  });
};

function isDisabled(panel: Feedback): boolean {
  return old_feedback?.some(feedback => feedback.id === panel.id) ?? false;
}

const isReadonly = computed(() => {
  if (props.readonly) {
    return true;
  }
  return record.value?.state == 1;
});

const removeFeedback = (index: number) => {
  panels.splice(index, 1);
};

function openPopup() {
  closeFeedbackPopup.value?.open(
      CloseFeedbackForm,
      {
        onClose: closeFeedbackPopup.value.close,
        modelValue: record,
        /*onSubmit: (value: Aufgabe) => {
          Object.assign(record, value);
        }*/
      },
      {
        dialogTitle: "Auftrag Beenden",
        maxWidth: 500
      }
  );
}

watch(() => record, (newVal) => {
  props.onChange?.();
  useGlobalSetting().hasChanged = true;
}, {deep: true});

</script>
